class FreeShippingBar extends HTMLElement {
  connectedCallback() {
    this.fill = this.querySelector('.free-shipping__fill');
    if (!this.fill) return;

    const progress = Number(this.dataset.progress) || 0;
    const storageKey = `free-shipping-progress:${this.dataset.key}`;
    const previous = this.readProgress(storageKey);
    this.writeProgress(storageKey, progress);

    // The cart re-renders by replacing markup, so start from the value this bar showed last and animate to the new one.
    this.fill.style.transition = 'none';
    this.fill.style.width = `${previous}%`;
    this.fill.offsetWidth;
    this.fill.style.transition = '';

    requestAnimationFrame(() => {
      this.fill.style.width = `${progress}%`;
    });

    if (progress >= 100 && previous < 100) {
      this.classList.add('is-celebrating');
    }
  }

  readProgress(key) {
    try {
      return Number(window.sessionStorage.getItem(key)) || 0;
    } catch (e) {
      return 0;
    }
  }

  writeProgress(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (e) {
      // Storage unavailable: the bar still animates from empty.
    }
  }
}
customElements.define('free-shipping-bar', FreeShippingBar);
